/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConstraintsTemplateOptions } from "./ConstraintsTemplateOptions";
import { AutobuildTemplateOptions } from "./AutobuildTemplateOptions";
import { AutocastTemplateOptions } from "./AutocastTemplateOptions";
import { WebhookEgressTemplateOptions } from "./WebhookEgressTemplateOptions";
import { ActionListenerTemplateOptions } from "./ActionListenerTemplateOptions";
import { AutomapTemplateOptions } from "./AutomapTemplateOptions";
export const TemplateOptions = core.serialization
    .union("template", {
    constraints: ConstraintsTemplateOptions,
    autobuild: AutobuildTemplateOptions,
    autocast: AutocastTemplateOptions,
    "webhook-egress": WebhookEgressTemplateOptions,
    "action-listener": ActionListenerTemplateOptions,
    automap: AutomapTemplateOptions,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
